// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"d0c81121","352":"46cf850f","488":"21a3b654","605":"d3a919c9","982":"10168c26"}[chunkId] + ".chunk.js";
};